const MAPBOX_ACCESS_TOKEN = process.env.REACT_APP_MAPBOX_ACCESS_TOKEN;

const MAPBOX_STYLE = process.env.REACT_APP_MAPBOX_STYLE;

const MAPBOX_USER_ID = process.env.REACT_APP_MAPBOX_USER_ID;

const INITIAL_CENTER = [-98.307, 30.613];
const INITIAL_ZOOM = 7.01;
const MAX_ZOOM = 18;

// Pixel tolerance for pointer hit-testing (the queryRenderedFeatures bbox).
// Shared by the click popup (useMapClickPopup) and the asset-map hover so a
// click and a hover trigger on the same target size.
const MAP_HIT_RADIUS_PX = 2;

const CONTROL_IDS = {
  FILTERS: "filters",
  GRID_SEARCH: "gridSearch",
  MAP_STYLES: "mapStyles",
  CHARTS: "charts",
};

const WELL_LAYERS = [
  "Bottoms",
  "Surface",
  "Laterals",
  "Bottoms_potential",
  "Surface_potential",
  "Laterals_potential",
];

// const UNITS_SOURCE_ID = "units";
// const UNITS = "Units";
// const UNITS_BORDER = "Units border";
// const UNITS_BORDER_HIGHLIGHT = "Units border highlighted";
// const UNITS_LAYERS = [UNITS, UNITS_BORDER];

// const ASSETS_SOURCE_ID = "assets";
// const ASSETS = "Assets";
// const ASSETS_BORDER = "Assets border";
// const ASSETS_BORDER_HIGHLIGHT = "Assets border highlighted";
// const ASSETS_LAYERS = [ASSETS, ASSETS_BORDER];

export {
  MAPBOX_USER_ID,
  MAPBOX_ACCESS_TOKEN,
  MAPBOX_STYLE,
  INITIAL_CENTER,
  INITIAL_ZOOM,
  MAX_ZOOM,
  MAP_HIT_RADIUS_PX,
  WELL_LAYERS,
  CONTROL_IDS,
};
